'use strict';

var GridAddRowButtonController = function GridAddRowButtonController($scope, systemConfigButtonsUtilsService) {
  var gridPanel = $scope.gridPanelScope;
  $scope.isGridEditable = gridPanel.jqxGridSettings.editable;
  $scope.isAddRowButtonShown = $scope.isGridEditable && !$scope.isDefaultLevel;
  $scope.addRow = function () {
    systemConfigButtonsUtilsService.addRowToGrid({
      isNewlyAdded: true
    }, gridPanel, $scope.customAddNew);
    systemConfigButtonsUtilsService.reloadGrid(gridPanel);
  };
};
GridAddRowButtonController.$inject = ['$scope', 'SystemConfigButtonsUtilsService'];
module.exports = GridAddRowButtonController;